// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"19351":"a5ce6a92","46832":"c42ece5b"}[chunkId] || chunkId) + "." + {"19351":"ab7e97a748699ec2","42294":"d5b630608fbca581","46832":"5a2abdfd83fc2dcd","53348":"96d9e062d8c32a88","65864":"fd91b83d9f1be3f8","68811":"a667c8e43a5a6739"}[chunkId] + ".js";
};